var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',{staticStyle:{"font-size":"30px"}},[_vm._v(_vm._s(_vm.title))]),(_vm.getEmployment)?_c('b-tabs',_vm._l((_vm.components),function(ref){
var title = ref[0];
var component = ref[1];
return _c('b-tab',{key:title,attrs:{"title":title}},[_c(component,{tag:"component",staticClass:"mt-3",attrs:{"employment":_vm.employment,"reload":_vm.reload}})],1)}),1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }